<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="mx-auto my-2 pt-1 card boxStyle"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path" class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0 mt-3">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "headerDesign",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'ساده',
                    value: 'simple',
                    full_path: require('../../../../public/media/site/office3/NEW/ساده.png')
                },
                {
                    id: '2',
                    name: 'کلاسیک',
                    value: 'classic',
                    full_path: require('../../../../public/media/site/office3/NEW/کلاسیک.jpg')
                },
                {
                    id: '3',
                    name: 'لوکس',
                    value: 'luxury',
                    full_path: require('../../../../public/media/site/office3/NEW/لوکس.jpg')
                },
                {
                    id: '4',
                    name: 'خلاق',
                    value: 'innovative',
                    full_path: require('../../../../public/media/site/office3/NEW/خلاق.jpg')
                },
                {
                    id: '5',
                    name: 'اداری/سازمانی',
                    value: 'office',
                    full_path: require('../../../../public/media/site/office3/NEW/اداری-و-سازمانی.jpg')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"headerDesign")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>